module.exports = __webpack_public_path__ + "media/brewdog-demo.80b5f2c8.mp4";